module.exports = __webpack_public_path__ + "img/ic_cognition.6ade37d1.png";